import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "index mentor"
};
const _hoisted_3 = { class: "fv" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "p_1" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("br", { class: "pc2" }, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", null, "メンター大募集", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "p_2" }, [
    /*#__PURE__*/ _createTextVNode("中小企業経営者向けの定額クラウド・ビジネス相談窓口"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode("「ShareMentors」")
], -1);
const _hoisted_10 = { class: "wrapper_1 home-wrapper" };
const _hoisted_11 = { class: "inner2 home-inner" };
const _hoisted_12 = { class: "sec1" };
const _hoisted_13 = /*#__PURE__*/ _createStaticVNode("<h3>ShareMentors とは？</h3><p> 中小企業のビジネス課題に、様々な経験者が応えます。<br class=\"pc\"> ビジネスに関する困りごとを、web上で質問投稿すると<br class=\"pc\"> 厳選された多業種・多様な経験者がすぐに回答する仕組みです。<br class=\"pc\"> メンターは、得意分野の相談があれば回答して、その評価に応じて報酬を得ることができます。<br class=\"pc\"> また、公開されたビジネス相談と他者の回答によって学びの機会得ることができます。<br><br> 個人事業主や小規模の中小企業には、IT・マーケティングなど専門部門がなくて<br class=\"pc\"> 代表者が代行されているケースが多いですが、それを補完できるサービスを目的としています。<br class=\"pc\"> ビジネス上の様々な疑問について気軽に相談ができて、中小企業の成長に貢献できることを目指しています。<br class=\"pc\"></p>", 2);
const _hoisted_15 = { class: "step" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "sec1" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "ShareMentors の相談分野"),
    /*#__PURE__*/ _createElementVNode("p", null, "ＩＴ系を中心に次のような職種の専門家に相談できます。"),
    /*#__PURE__*/ _createElementVNode("ul", { class: "category" }, [
        /*#__PURE__*/ _createElementVNode("li", null, "・経営/事業"),
        /*#__PURE__*/ _createElementVNode("li", null, "・マーケ/広報"),
        /*#__PURE__*/ _createElementVNode("li", null, "・営業"),
        /*#__PURE__*/ _createElementVNode("li", null, "・販売/サービス"),
        /*#__PURE__*/ _createElementVNode("li", null, "・ITエンジニア"),
        /*#__PURE__*/ _createElementVNode("li", null, "・クリエイター")
    ])
], -1);
const _hoisted_17 = { class: "sec2" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("h3", null, "ShareMentors の相談ケース", -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("p", null, "次のようなことでお困りの方に向けたサービスです。", -1);
const _hoisted_20 = { class: "sec3" };
const _hoisted_21 = { class: "inner" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("h3", null, "ShareMentors の特長", -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("p", null, "メンターにとって、次のような特長・メリットがあります。", -1);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "1", -1);
const _hoisted_25 = { class: "title" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "相談を選んで回答できる", -1);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, "オールマイティーでなくてもご自身の知見の範囲で回答が可能です。", -1);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "2", -1);
const _hoisted_29 = { class: "title" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "空き時間に回答できる", -1);
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, "ご自身の時間的余裕がある時に、ご利用できます。", -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "3", -1);
const _hoisted_33 = { class: "title" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "社会貢献できる", -1);
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, "多くの相談者に喜ばれ、中小企業の成長に貢献できます。", -1);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "4", -1);
const _hoisted_37 = { class: "title" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "報酬を得る", -1);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, "優れた回答すれば報酬を得ることができます。", -1);
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "5", -1);
const _hoisted_41 = { class: "title" };
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "学びを得る", -1);
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, " 相談をきっかけに広く/深く探究する機会を得ます。他者の回答から学ぶことができます。また、相談者（≒顧客）のニーズを知ることができる、という側面もあります。 ", -1);
const _hoisted_44 = { class: "plate" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("h4", null, "他サービスとの比較", -1);
const _hoisted_46 = { class: "sec4" };
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("h3", null, "相談イメージ", -1);
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("div", { class: "step" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "1"),
    /*#__PURE__*/ _createElementVNode("p", null, "相談と回答･･･チャット方式で相談者は各メンターとQ＆A")
], -1);
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("div", { class: "step" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "2"),
    /*#__PURE__*/ _createElementVNode("p", null, "相談終了…相談者によるランキングとコメント入力")
], -1);
const _hoisted_50 = { class: "sec5" };
const _hoisted_51 = { class: "inner" };
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("h3", null, "報酬", -1);
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode("相談終了時に、相談者により、評価の高かった上位３名の回答が選ばれます。"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode("その順位に応じて、次のようにメンターへ報酬が支払われます。")
], -1);
const _hoisted_54 = { class: "price_box" };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("div", { class: "title" }, " "),
    /*#__PURE__*/ _createElementVNode("div", { class: "t1" }, "回答者が３名以上の時"),
    /*#__PURE__*/ _createElementVNode("div", { class: "t2" }, "回答者が２名の時"),
    /*#__PURE__*/ _createElementVNode("div", { class: "t3" }, "回答者が１名の時")
], -1);
const _hoisted_56 = { class: "title" };
const _hoisted_57 = /*#__PURE__*/ _createStaticVNode("<div class=\"t1\"><p class=\"tt\">回答者が３名以上の時</p><p class=\"price\">1,500<span>円</span></p></div><div class=\"t2\"><p class=\"tt\">回答者が２名の時</p><p class=\"price\">1,500<span>円</span></p></div><div class=\"t3\"><p class=\"tt\">回答者が１名の時</p><p class=\"price\">2,000<span>円</span></p></div>", 3);
const _hoisted_60 = { class: "title" };
const _hoisted_61 = /*#__PURE__*/ _createStaticVNode("<div class=\"t1\"><p class=\"tt\">回答者が３名以上の時</p><p class=\"price\">400<span>円</span></p></div><div class=\"t2\"><p class=\"tt\">回答者が２名の時</p><p class=\"price\">500<span>円</span></p></div><div class=\"t3\"><p class=\"tt\">回答者が１名の時</p><p class=\"price\">ー</p></div>", 3);
const _hoisted_64 = { class: "title" };
const _hoisted_65 = /*#__PURE__*/ _createStaticVNode("<div class=\"t1\"><p class=\"tt\">回答者が３名以上の時</p><p class=\"price\">100<span>円</span></p></div><div class=\"t2\"><p class=\"tt\">回答者が２名の時</p><p class=\"price\">ー</p></div><div class=\"t3\"><p class=\"tt\">回答者が１名の時</p><p class=\"price\">ー</p></div>", 3);
const _hoisted_68 = /*#__PURE__*/ _createStaticVNode("<li><div class=\"title\">表彰なし</div><div class=\"t1\"><p class=\"tt\">回答者が３名以上の時</p><p class=\"price\">0<span>円</span></p></div><div class=\"t2\"><p class=\"tt\">回答者が２名の時</p><p class=\"price\">ー</p></div><div class=\"t3\"><p class=\"tt\">回答者が１名の時</p><p class=\"price\">ー</p></div></li>", 1);
const _hoisted_69 = /*#__PURE__*/ _createElementVNode("div", { class: "under" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "※報酬額は将来変更となる可能性があります。"),
    /*#__PURE__*/ _createElementVNode("p", null, "※1つの相談に対してQ＆Aが繰り返され、終了が確定するまで（１～２週間程）を１件とします。"),
    /*#__PURE__*/ _createElementVNode("p", null, "※相談者による順位付けがなかった場合には、回答者全員で均等割りとします。")
], -1);
const _hoisted_70 = { class: "sec6" };
const _hoisted_71 = /*#__PURE__*/ _createStaticVNode("<h3>よくあるご質問</h3><h4>申込</h4><ul class=\"faq\"><li>誰でも登録できますか？</li><li>事前審査があります。弊社の基準に満たない場合にはメンターになれませんので予めご了承下さい。</li></ul><h4>相談・回答</h4><ul class=\"faq\"><li>自身や自社の情報を余り公開したくないのですが？</li><li>表示名、業種、職種、スキル要約は必須で公開表示されます。<br>職歴は審査のために必須ですが、公開か非公開かを選択できます。<br> また、本名や電話番号、住所などの連絡先の情報は必須ですが非公開です。</li><li>回答に対してどこまで責任が問われますか？</li><li>当社、およびメンターは相談の回答に従って生じた損害について責任を負いません。</li><li>ビデオ会議には対応していますか？</li><li>現状はチャット方式のみです。</li></ul><h4>決済</h4>", 6);
const _hoisted_77 = { class: "faq" };
const _hoisted_78 = /*#__PURE__*/ _createElementVNode("li", null, "報酬の受け取り方法は？", -1);
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_80 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_81 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_82 = /*#__PURE__*/ _createElementVNode("a", {
    href: "https://www.jp-bank.japanpost.jp/kojin/sokin/koza/kj_sk_kz_furikomi_ksk.html",
    target: "_blank"
}, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: "images/common/i_outlink.svg",
        alt: "",
        class: "i_link"
    }),
    /*#__PURE__*/ _createTextVNode(" 振込(他の金融機関口座への送金) ")
], -1);
const _hoisted_83 = /*#__PURE__*/ _createElementVNode("h4", null, "退会", -1);
const _hoisted_84 = /*#__PURE__*/ _createElementVNode("ul", { class: "faq" }, [
    /*#__PURE__*/ _createElementVNode("li", null, "想定していたサービスと違っていたらすぐに退会することができますか？"),
    /*#__PURE__*/ _createElementVNode("li", null, "はい、退会することはできます。但し、未受取りの報酬はお受取りできません。")
], -1);
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import InertiaUtil from '@util/InertiaUtil';
import { PlanCategory, UserType } from '@util/Consts';
import ImageFrame from '@component/ImageFrame.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'mentors',
    props: {
        common: null
    },
    setup(__props) {
        const props = __props;
        const onClickSignUp = () => {
            const form = InertiaUtil.getForm({
                type: UserType.MENTOR,
                plan_id: PlanCategory.FREE_PLAN,
            });
            form.get(route('signup'));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createTextVNode("あなたの経験が中小企業の役に立ちます。"),
                                    _hoisted_6,
                                    _createTextVNode(" 新規サービス立ち上げのため、"),
                                    _hoisted_7,
                                    _createTextVNode(" 多業種・多様な経歴を持った"),
                                    _hoisted_8,
                                    _createVNode(ImageFrame, { src: "images/mentors/i_fv_word.svg" })
                                ]),
                                _createVNode(ImageFrame, {
                                    class: "pop",
                                    src: "images/mentors/i_fv_pop.svg"
                                }),
                                _hoisted_9,
                                _createVNode(ImageFrame, { src: "images/index/i_fv.png" })
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _hoisted_13,
                                    _createElementVNode("ul", _hoisted_15, [
                                        _createElementVNode("li", null, [
                                            _createVNode(ImageFrame, { src: "images/index/sec1_1.png" }),
                                            _createVNode(_unref(Link), {
                                                href: _ctx.route('home')
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("相談したいという方はこちら")
                                                ]),
                                                _: 1
                                            }, 8, ["href"])
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(ImageFrame, {
                                                class: "pc",
                                                src: "images/index/sec1_2.png"
                                            }),
                                            _createVNode(ImageFrame, {
                                                class: "sp",
                                                src: "images/index/sec1_2_sp.png"
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(ImageFrame, { src: "images/index/sec1_3.png" })
                                        ])
                                    ])
                                ]),
                                _hoisted_16,
                                _createElementVNode("div", _hoisted_17, [
                                    _hoisted_18,
                                    _hoisted_19,
                                    _createVNode(ImageFrame, {
                                        class: "pc",
                                        src: "images/index/sec2_pc.jpg"
                                    }),
                                    _createVNode(ImageFrame, {
                                        class: "sp",
                                        src: "images/index/sec2_sp.jpg"
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _hoisted_22,
                                        _hoisted_23,
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _hoisted_24,
                                                _createElementVNode("div", _hoisted_25, [
                                                    _hoisted_26,
                                                    _createVNode(ImageFrame, { src: "images/mentors/icon_1.svg" })
                                                ]),
                                                _hoisted_27
                                            ]),
                                            _createElementVNode("li", null, [
                                                _hoisted_28,
                                                _createElementVNode("div", _hoisted_29, [
                                                    _hoisted_30,
                                                    _createVNode(ImageFrame, { src: "images/mentors/icon_2.svg" })
                                                ]),
                                                _hoisted_31
                                            ]),
                                            _createElementVNode("li", null, [
                                                _hoisted_32,
                                                _createElementVNode("div", _hoisted_33, [
                                                    _hoisted_34,
                                                    _createVNode(ImageFrame, { src: "images/mentors/icon_3.svg" })
                                                ]),
                                                _hoisted_35
                                            ]),
                                            _createElementVNode("li", null, [
                                                _hoisted_36,
                                                _createElementVNode("div", _hoisted_37, [
                                                    _hoisted_38,
                                                    _createVNode(ImageFrame, { src: "images/mentors/icon_4.svg" })
                                                ]),
                                                _hoisted_39
                                            ]),
                                            _createElementVNode("li", null, [
                                                _hoisted_40,
                                                _createElementVNode("div", _hoisted_41, [
                                                    _hoisted_42,
                                                    _createVNode(ImageFrame, { src: "images/mentors/icon_5.svg" })
                                                ]),
                                                _hoisted_43
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_44, [
                                            _hoisted_45,
                                            _createVNode(ImageFrame, { src: "images/mentors/sec4.jpg" })
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                    _hoisted_47,
                                    _hoisted_48,
                                    _createVNode(ImageFrame, { src: "images/index/sec5_1.jpg" }),
                                    _hoisted_49,
                                    _createVNode(ImageFrame, { src: "images/index/sec5_2.jpg" })
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                        _hoisted_52,
                                        _hoisted_53,
                                        _createElementVNode("ul", _hoisted_54, [
                                            _hoisted_55,
                                            _createElementVNode("li", null, [
                                                _createElementVNode("div", _hoisted_56, [
                                                    _createVNode(ImageFrame, { src: "images/mentors/i_crown.svg" }),
                                                    _createTextVNode("金賞 ")
                                                ]),
                                                _hoisted_57
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("div", _hoisted_60, [
                                                    _createVNode(ImageFrame, { src: "images/mentors/i_crown.svg" }),
                                                    _createTextVNode("銀賞 ")
                                                ]),
                                                _hoisted_61
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("div", _hoisted_64, [
                                                    _createVNode(ImageFrame, { src: "images/mentors/i_crown.svg" }),
                                                    _createTextVNode("銅賞 ")
                                                ]),
                                                _hoisted_65
                                            ]),
                                            _hoisted_68
                                        ]),
                                        _hoisted_69,
                                        _createElementVNode("a", {
                                            class: "bt_application",
                                            onClick: onClickSignUp,
                                            style: { "cursor": "pointer" }
                                        }, "今すぐ応募(無料)")
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_70, [
                                    _hoisted_71,
                                    _createElementVNode("ul", _hoisted_77, [
                                        _hoisted_78,
                                        _createElementVNode("li", null, [
                                            _createTextVNode(" 銀行口座へのお振込みとなります。"),
                                            _hoisted_79,
                                            _createTextVNode(" お振込み条件は、報酬残高の合計が5,000円以上で月末締め翌月末日払いです。"),
                                            _hoisted_80,
                                            _createTextVNode(" 振込手数料として" + _toDisplayString(__props.common.transfer_fee) + "円をお客様ご負担とさせて頂きます。", 1),
                                            _hoisted_81,
                                            _createTextVNode(" なお、ゆうちょ銀行の場合は "),
                                            _hoisted_82,
                                            _createTextVNode(" の情報に基づきご登録ください。 ")
                                        ])
                                    ]),
                                    _hoisted_83,
                                    _hoisted_84,
                                    _createElementVNode("a", {
                                        class: "bt_application",
                                        onClick: onClickSignUp,
                                        style: { "cursor": "pointer" }
                                    }, "今すぐ応募(無料)")
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
